import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface RouteTransitionLoaderProps {
  children: React.ReactNode;
}

const RouteTransitionLoader: React.FC<RouteTransitionLoaderProps> = ({ children }) => {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayChildren, setDisplayChildren] = useState(true);
  const prevPathnameRef = useRef<string>(location.pathname);

  useEffect(() => {
    // Only show loader if pathname actually changed (not on initial load)
    if (prevPathnameRef.current !== location.pathname && prevPathnameRef.current !== '') {
      // Start transition
      setIsTransitioning(true);
      setDisplayChildren(false);

      // Show loading for a minimum time (native-like feel)
      // This ensures smooth transition even if data loads instantly
      const minLoadTime = 250; // 250ms minimum for smooth transition
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        // Small delay before showing content for smooth fade-in
        setTimeout(() => {
          setDisplayChildren(true);
        }, 100);
      }, minLoadTime);

      prevPathnameRef.current = location.pathname;

      return () => {
        clearTimeout(timer);
      };
    } else {
      // Initial load - show content immediately, no transition
      if (prevPathnameRef.current === '') {
        prevPathnameRef.current = location.pathname;
      }
      setDisplayChildren(true);
      setIsTransitioning(false);
    }
  }, [location.pathname]);

  return (
    <>
      {isTransitioning && (
        <div className="route-transition-loader">
          <div className="loading-logo">
            <img src="logo512.png" alt="Shikhun Italian" />
          </div>
        </div>
      )}
      <div className={`route-content ${isTransitioning ? 'hidden' : 'visible'}`}>
        {children}
      </div>
    </>
  );
};

export default RouteTransitionLoader;

